import Backbone from 'backbone';

export var PmlayerView = Backbone.View.extend({
  initialize: function () {
    this.listenTo(this.model, 'change:isVisible', this.render);
    this.render();
  },

  events: {
    'click [data-pmlayer-close]': 'handleClose'
  },

  handleClose: function (e) {
    e.preventDefault();
    var checked = this.$('[data-pmlayer-dismiss]').is(':checked');
    this.model.set('isTodayDismiss', checked);
    this.model.setClose();
  },

  render: function () {
    if (this.model.get('isVisible')) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
    return this;
  }
});
